import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
class TrustpilotScript extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx("script", {
            type: "text/javascript",
            src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
            async: true,
            defer: true
        });
    }
}
export { TrustpilotScript as default };
